import { render, staticRenderFns } from "./ContextualArchetype.vue?vue&type=template&id=43566578&scoped=true"
import script from "./ContextualArchetype.vue?vue&type=script&lang=ts"
export * from "./ContextualArchetype.vue?vue&type=script&lang=ts"
import style0 from "./ContextualArchetype.vue?vue&type=style&index=0&id=43566578&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43566578",
  null
  
)

export default component.exports